// config..js

export const BASE_URL = "https://chat.realtyseek.ai";
export const API_BASE_URL = "https://api.realtyseek.ai";
export const WSS_CHAT_CONN_URL = "wss://api.realtyseek.ai/ws/chat";
export const REQUIRE_GUEST_INFO = true; // Configure as needed
export const MAX_GUEST_QUERIES = 5; // Set to 0 for immediate prompt


export const introductionText = `
# 🏡 AI Real Estate Buddy
**🔍 Find, Compare & Invest – Smarter Than Ever!**

Welcome to RealtySeek.ai, your AI-powered real estate assistant designed to help you **find**, **analyze**, and **invest** in properties with confidence. Whether you're a homebuyer, investor, or real estate enthusiast, get instant, data-driven insights to make informed decisions—faster and smarter!

## How It Works
- **Ask Anything** – Get real-time property insights, price trends, and investment potential.  
- **Compare Properties** – Evaluate options side-by-side to find the best fit.  
- **Make Smarter Decisions** – Access expert AI guidance for buying, selling, or investing.

---
🚀 Start your real estate journey now—simply **ask a question**!
`;

export const introductionTextMobile = `
# **🏡 AI Real Estate Buddy**
**Your trusted partner for all property needs.**
**🏡 RealtySeek.ai – Smarter Real Estate Decisions!**  
🤖 AI-powered insights for buyers & investors.  
✅ Quick property comparisons  
✅ Instant market trends  
✅ Smart investment advice  
🚀 **Start your real estate journey now—simply ask a question!**
`;

